var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-area',{staticClass:"mb-8",attrs:{"page":_vm.banners,"img":_vm.img}}),_vm._v(" "),(_vm.proyects.length > 0 )?_c('div',{staticClass:"mb-8"},[_c('proyectos-area',{attrs:{"proyectos":_vm.proyects,"vermas":true}})],1):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a78bf9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/proyectos_post.vue
// module id = zvkg
// module chunks = 0